import http from '../libs/http'

export const newOssInfo = (data) => {
  return http.post({
    url: '/api/ossInfo',
    data,
  }).then((res) => {
    return res;
  })
};

export const updateOssInfo = (data) => {
  return http.put({
    url: '/api/ossInfo',
    data,
  }).then((res) => {
    return res;
  })
};


export const getOssTemplates = (projectId) => {
  return http.get({
    url: '/api/ossInfos',
    data: {
      params: {
        projectId
      }
    }
  }).then((res) => {
    return res;
  })
};

export const deleteOssTemplate = (uuid) => {
  return http.delete({
    url: '/api/ossInfo',
    data: {
      params: {
        uuid
      }
    }
  }).then((res) => {
    return res;
  })
};

export const createOssEnv = (appId, name, ossEnvInfo) => {
  return http.post({
    url: '/api/app/ossEnv',
    data: {
      appId,
      name,
      ossEnvInfo,
    }
  }).then((res) => {
    return res;
  });
};

export const updateOssEnv = (appId, uuid, ossEnvInfo) => {
  return http.put({
    url: '/api/app/ossEnv',
    data: {
      appId,
      uuid,
      ossEnvInfo,
    }
  }).then((res) => {
    return res;
  });
};

export const deleteOssEnv = (appId, uuid) => {
  return http.delete({
    url: '/api/app/ossEnv',
    data: {
      params: {
        appId,
        uuid,
      }
    }
  }).then((res) => {
    return res;
  });
};

export const getOssEnvs = (appId) => {
  return http.get({
    url: '/api/app/ossEnvs',
    data: {
      params: {
        appId,
      }
    }
  }).then((res) => {
    return res;
  })
};



// WEBPACK FOOTER //
// ./src/apis/oss_apis.js